import {
	CREATE, GET_ONE,
	UPDATE,
	UPDATE_MANY,
} from 'react-admin';

import { USER_PROFILE } from '../constants/resources';
import { statuses } from '../resources/UserProfile';
import { createProfileByAdmin } from '../model/cloud';


export const clearConfirmationMessage = (requestHandler) => (type, resource, params) => {
	if (resource === USER_PROFILE) {
		switch (type) {
			case CREATE:
				requestHandler.pointerizeData(params.data, requestHandler.modelHint, resource);
				return createProfileByAdmin(params.data)
					.then((id) => requestHandler(GET_ONE, resource, { id }));
			case UPDATE:
			case UPDATE_MANY:
				if (params.data.profileStatus !== statuses.rejected && params.data.confirmationMessage) {
					params.data.confirmationMessage = ''; // eslint-disable-line no-param-reassign
				}
				return requestHandler(type, resource, params);
			default:
				break;
		}
	}

	return false;
};
